import { render, staticRenderFns } from "./UserProfileContractCard.vue?vue&type=template&id=9671ebbc&scoped=true"
import script from "./UserProfileContractCard.vue?vue&type=script&lang=js"
export * from "./UserProfileContractCard.vue?vue&type=script&lang=js"
import style0 from "./UserProfileContractCard.vue?vue&type=style&index=0&id=9671ebbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9671ebbc",
  null
  
)

export default component.exports